/** Manage profile widgets: hours / cities / price / tags (BusinessManageForm children) */

const hoursEditor = {
  dayMon: ['월', 'Mon', 'T2', 'Пн'],
  dayTue: ['화', 'Tue', 'T3', 'Вт'],
  dayWed: ['수', 'Wed', 'T4', 'Ср'],
  dayThu: ['목', 'Thu', 'T5', 'Чт'],
  dayFri: ['금', 'Fri', 'T6', 'Пт'],
  daySat: ['토', 'Sat', 'T7', 'Сб'],
  daySun: ['일', 'Sun', 'CN', 'Вс'],
  closed: ['휴무', 'Closed', 'Nghỉ', 'Выходной'],
  badge24h: ['24H', '24H', '24H', '24ч'],
  applyWeekdays: [
    '평일(월~금) 일괄 적용',
    'Apply Mon–Fri',
    'Áp dụng T2–T6',
    'Применить Пн–Пт',
  ],
  applyWeekend: [
    '주말(토~일) 일괄 적용',
    'Apply Sat–Sun',
    'Áp dụng T7–CN',
    'Применить Сб–Вс',
  ],
  toggleHint: [
    '요일 버튼 터치로 영업/휴무 전환',
    'Tap a day to toggle open / closed',
    'Chạm ngày để đổi mở/đóng',
    'Нажмите день, чтобы сменить открыто/закрыто',
  ],
};

const citySelector = {
  searchChip: ['🔍 직접 검색', '🔍 Search cities', '🔍 Tìm thành phố', '🔍 Поиск городов'],
  searchPlaceholder: ['도시 검색', 'Search cities', 'Tìm thành phố', 'Поиск города'],
  loading: [
    '도시 목록 불러오는 중…',
    'Loading cities…',
    'Đang tải danh sách thành phố…',
    'Загрузка городов…',
  ],
  noResults: [
    '검색 결과가 없어요. (이 나라에 등록된 도시만 검색됩니다)',
    'No cities found (only cities registered for this country).',
    'Không có kết quả (chỉ tìm thành phố đã đăng ký của quốc gia này).',
    'Ничего не найдено (только города этой страны).',
  ],
  removeAria: ['제거', 'Remove', 'Xóa', 'Удалить'],
};

const priceInput = {
  placeholder: ['최저가 입력', 'Enter lowest price', 'Nhập giá thấp nhất', 'Минимальная цена'],
  sortHint: [
    '허브 페이지 가격순 정렬에 활용돼요',
    'Used for price sorting on the hub page',
    'Dùng để sắp xếp theo giá trên trang hub',
    'Нужно для сортировки по цене на хабе',
  ],
};

const hubTags = {
  needSub: [
    '먼저 위에서 업종(예: 액티비티, 투어)을 선택해 주세요.',
    'Select a subcategory above first (e.g. Activity, Tour).',
    'Hãy chọn ngành phụ ở trên trước (vd: Hoạt động, Tour).',
    'Сначала выберите подкатегорию выше (напр. Активность, Тур).',
  ],
  loading: [
    '세부 종류 불러오는 중…',
    'Loading tags…',
    'Đang tải loại chi tiết…',
    'Загрузка тегов…',
  ],
  empty: [
    '이 업종에 등록된 세부 종류가 없어요.',
    'No detail tags are registered for this subcategory.',
    'Chưa có loại chi tiết cho ngành này.',
    'Для этой подкатегории нет тегов.',
  ],
};

const customTags = {
  needSub: [
    '먼저 위에서 업종(예: 액티비티)을 선택해 주세요.',
    'Select a subcategory above first (e.g. Activity).',
    'Hãy chọn ngành phụ ở trên trước (vd: Hoạt động).',
    'Сначала выберите подкатегорию выше (напр. Активность).',
  ],
  add: ['추가', 'Add', 'Thêm', 'Добавить'],
  removeTitle: ['탭하여 삭제', 'Tap to remove', 'Chạm để xóa', 'Нажмите, чтобы удалить'],
  placeholderPrefix: [
    '직접 추가 (예: {examples})',
    'Add custom (e.g. {examples})',
    'Thêm thủ công (vd: {examples})',
    'Добавить своё (напр. {examples})',
  ],
  hint: [
    '추천 목록에 없으면 직접 입력하세요. 검색·AI 추천에 반영되며, 많이 쓰이면 허브 필터에 추가됩니다.',
    'If it’s not in the list, type your own. Used for search & AI; popular tags may become hub filters.',
    'Nếu không có trong gợi ý, hãy tự nhập. Dùng cho tìm kiếm & AI; tag phổ biến có thể vào bộ lọc hub.',
    'Если нет в списке — введите своё. Участвует в поиске и AI; популярные попадут в фильтры хаба.',
  ],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, arr]) => {
    out[k] = arr[langIndex];
  });
  return out;
}

function buildLang(langIndex) {
  return {
    dashboard: {
      hoursEditor: pick(hoursEditor, langIndex),
      citySelector: pick(citySelector, langIndex),
      priceInput: pick(priceInput, langIndex),
      hubTags: pick(hubTags, langIndex),
      customTags: pick(customTags, langIndex),
    },
  };
}

export const phaseManageWidgetsKo = buildLang(0);
export const phaseManageWidgetsEn = buildLang(1);
export const phaseManageWidgetsVi = buildLang(2);
export const phaseManageWidgetsRu = buildLang(3);
